module.exports = __webpack_public_path__ + "img/Leonos_32@2x.aaf9ee9f.png";